import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "the-mobile-app",
  courseId: "getting-started",
  order: 6,
  title: "The mobile app",
  subtitle: "Record on scene, finish at your desk",
  summary:
    "Record the narrative on the iOS app while the call is fresh. The case syncs to the web app, so the draft is waiting when you sit down.",
  learn: [
    "Record a narrative on your phone and send it for drafting",
    "Find the Cases, Forms, and Files tabs on iOS",
    "Pick up the same case on the web to review and export",
  ],
  minutes: 3,
  releasedAt: "2026-10-15T00:00:00.000Z",
  platform: "ios",
  body: [
    {
      type: "paragraph",
      text: "Dictating while the call is fresh produces better reports than typing from memory an hour later. On the iOS app you record, add a line of context, and upload, and the case appears in your web account with the draft in progress.",
    },
    {
      type: "steps",
      items: [
        "Install Police Narratives AI from the App Store and sign in with the same account you use on the web.",
        "Turn on biometric login when prompted.",
        "On the **Cases** tab, tap the record button and speak the narrative the way you would dictate it. Pause and resume as needed.",
        "When you stop, choose Narrative or Interaction, add any context, and upload.",
        "Back at your desk, open the same case on the web. Review the draft, work the suggestions, and export.",
      ],
    },
    {
      type: "paragraph",
      text: "You can lock the phone after you upload, since the upload finishes in the background. Biometric login saves you from typing a password in the car.",
    },
    { type: "heading", text: "What else is on the phone" },
    {
      type: "bullets",
      items: [
        "**Forms**: fill a department form from a recording, or add audio to a form you already filled.",
        "**Files**: your library of recordings and documents, the same one you see on the web.",
        "Live Translate: two-way spoken translation with a subject on scene, saved as case media. See the **Live Translate** lesson.",
        "Settings include multi-factor authentication, report preferences, and account deletion (iOS only).",
      ],
    },
    {
      type: "callout",
      tone: "tip",
      text: "Record on the phone, but edit on the web. The editor's side panels (Suggestions, Statutes, Snippets, Redactions) are built for a wide screen.",
    },
    {
      type: "callout",
      tone: "note",
      text: "If your agency enforces MFA, the phone asks for your authenticator or email code at sign-in, the same as the web. Device biometrics (Face ID) are a convenience on top, not a second factor.",
    },
  ],
  related: ["first-narrative-report", "live-translate", "multi-factor-authentication"],
};

export default lesson;
